import { useContext, useEffect, useState } from "react";
import { Button, Form } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import SelectInput from "../../components/ReactHookForm/SelectInput";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { hitEndpointTableros } from "./handlers";
import PulseOpacitySpinner from "../../components/MuniSpinner/PulseOpacitySpinner";
import { UserContext } from "../../context/UserWrapper";

const EndpointsTablero = () => {
  const [render, setRender] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { actions: ua } = useContext(UserContext);
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    formState: { errors },
  } = useForm({
    // resolver: yupResolver(endpointsSchema),
  });

  useEffect(() => {
    if (!ua.hasRole("sudo")) {
      navigate("/");
    }
    setValue("endpoint", "cantidad_actas_por_fecha");

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setValue]);

  return (
    <div>
      <div className='d-flex gap-4 align-items-center mb-4'>
        <h3 className='mb-0'>Endpoints Tablero</h3>
        <Link to='/' className='my-auto  ms-auto me-1 btn btn-primary' style={{ maxHeight: "38px" }}>
          <span>Volver</span>
        </Link>
      </div>
      <div className='d-flex flex-wrap gap-4'>
        <div className='me-5'>
          <Form onSubmit={handleSubmit((data) => hitEndpointTableros(data, getValues(["fecha_ini", "fecha_fin"]), setRender, setIsLoading, setError))}>
            <fieldset>
              <SelectInput
                name={`endpoint`}
                value='cantidad_actas_por_fecha'
                valueName='Cantidad de actas generadas'
                errors={errors.endpoint}
                label='Consulta *'
                register={register}
                data={[
                  { id: "cantidad_actas_pagas_por_fecha", name: "Cantidad de actas pagas" },
                  { id: "total_recaudacion", name: "Total recaudación" },
                  { id: "cantidad_actas_vencidas", name: "Actas vencidas" },
                  // { id: 'vista_de_acta_especifico', name: 'Vista específica de acta' },
                ]}
              />
              <div className='mb-2'>
                <label className='mb-2'>Fecha de inicio</label>
                <input className='form-control' type='date' {...register("fecha_ini")} />
                <p className='text-danger' style={{ fontSize: "14px" }}>
                  {errors?.fecha_ini?.message}
                </p>
              </div>
              <div className='mb-2'>
                <label className='mb-2'>Fecha fin</label>
                <input className='form-control' type='date' {...register("fecha_fin")} />
              </div>
              <Button type='submit'>Consultar</Button>
            </fieldset>
          </Form>
        </div>
        {/* {
          {
            'cantidad_actas_por_fecha': <CantidadActasPorFecha cantidadActas={cantidadActas} />,
            'cantidad_actas_pagas_por_fecha': <p>cantidad_actas_pagas_por_fecha</p>,
            'total_recaudacion': <p>total_recaudacion</p>,
            'cantidad_actas_vencidas': <p>actas_vencidas</p>,
            // 'vista_de_acta_especifico': <p>vista_de_acta_especifico</p>,
          }[watch('endpoint')] || 'default todo'
        } */}
        {isLoading ? (
          <div>
            <PulseOpacitySpinner />
          </div>
        ) : (
          render
        )}
      </div>
    </div>
  );
};

export default EndpointsTablero;
